export enum CampaignItemTypeEnum {
	CONTENT_RECOMMANDED = 19,
	ARTICLE_INSERTION = 21,
	SPLASH_POPUP=20,
	BESPOKEN=63,
	AUTOLOAD_ARTICLE=64,
}